// The legacy Pay Monthly summary page was removed after the redesign experiment concluded
// (CASHDAP-3350) — `summary-pay-monthly-redesign` is the canonical PM summary. This folder keeps
// the pieces other pages still use: `PlanOverview` and `style.module.css` (Apple Pay Later's
// consumer-lending summary, plus shared styles for the redesigned page).
export * from './PlanOverview'
